module.exports = __webpack_public_path__ + "media/images/icons/outlined/plus-circle-3158ccaa9c3ff7a8dcf0f897184b2239.svg";